import React, { useEffect, useState } from 'react';
import FiltersPanel from './FiltersPanel';
import { cx } from '../shared/ui/utils';

const MobileFiltersDrawer = ({
  open,
  filters,
  defaultFilters,
  onClose,
  onApply,
  labels = {},
  ...panelProps
}) => {
  const [draft, setDraft] = useState(filters);

  useEffect(() => {
    if (open) setDraft(filters);
  }, [open, filters]);

  const updateDraft = (patch) => {
    setDraft((prev) => ({ ...prev, ...patch }));
  };

  const resetDraft = () => {
    setDraft(defaultFilters);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      <button
        type="button"
        onClick={onClose}
        className="absolute inset-0 bg-slate-900/40"
        aria-label="Close filters"
      />
      <div
        className={cx(
          'absolute right-0 top-0 h-full w-full max-w-sm overflow-y-auto bg-white p-5 shadow-2xl transition'
        )}
      >
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-semibold text-slate-900">{labels.filtersLabel || 'Filters'}</h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded-full border border-slate-200 px-3 py-1 text-xs font-semibold"
          >
            Close
          </button>
        </div>
        <div className="mt-4">
          <FiltersPanel {...panelProps} filters={draft} onChange={updateDraft} onReset={resetDraft} compact />
        </div>
        <div className="sticky bottom-0 mt-6 flex gap-2 bg-white pt-4">
          <button
            type="button"
            onClick={resetDraft}
            className="flex-1 rounded-full border border-slate-200 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-slate-600"
          >
            {labels.resetFilters || 'Reset'}
          </button>
          <button
            type="button"
            onClick={() => {
              onApply(draft);
              onClose();
            }}
            className="flex-1 rounded-full bg-slate-900 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-white"
          >
            {labels.applyFilters || 'Apply filters'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileFiltersDrawer;
